/***
 * 轉換 Common Config 資料結構 
 * [[], []....] --> [{}, {}....]
 */
export function operationCommonConfigCombination(response_result) {
  let common_config = new Object();
  response_result.forEach(function (response) {
    common_config[response.area_name] = response;
  });

  return common_config;
}
